import css from "styled-jsx/css";
import { colors, grid } from "./constants";

export default css`
  .streaming-platforms-section {
    background-color: ${colors.color_emp__blue_dark};

    .content-container {
      
      margin: 0 auto;
      .container-button-configura {
          text-align: center;
          padding-bottom: 1rem;
      }
    }
  }

  // Mobile
  @media screen and (max-width: ${grid.breakpoint_sm}px) {
    .streaming-platforms-section {
      .content-container {
        .container-button-configura {
          :global(.button-configura) {
            min-width: 100%;
          }
        }
      }
    }

  }
  // Desktop
  @media screen and (min-width: ${grid.breakpoint_md}px) {
  }
`;
